const reportDB = require("../../../../../components/report/report-db");
const report = require("../../../../../components/report/report");
const style = require("../../../../../components/report/report-style");
const css = style.get();
const page = require("../../../../../components/page/page");
const math = require("../../../../../js-handler/math");
import { createChart } from "./chart/providerProfit-page-chart";


export function fetchAll(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = { entity: "provider", report: "account-all-profit" };
  if (detail.sort) {
    detail.inf.sort_by = detail.sort.by;
    detail.inf.sort_dir = detail.sort.dir;
  }

  if (detail.search) {
    detail.inf.searchReceivable = detail.search;
  }

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
    createChart(data);
    detail.skipReportPage = true; // Skip the report page
    report.show(detail, () => {
      const pageTarget = document.getElementById("providerProfit-page-right");
      const body = generate(data);

      pageTarget.insertAdjacentHTML("beforeend", body);
    });
  });
}

export function fetchOne(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "provider",
    report: "account-all-profit-one",
    dbid: detail.dbid,
  };

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

export function fetchUnpaidInvoices(detail, callback) {
  const phpFile = "server/php/sql/report.php";
  detail.inf = {
    entity: "provider",
    report: "account-profit-period",
    id: detail.dbid,
  };

  reportDB.select(detail, phpFile, (data) => {
    callback(data);
  });
}

function generate(data) {

  var body = ''
  body += generateTop(data)
  body += generateTable(data)
  body += `</div> <!-- dataCont -->`
  body += `<div class="report-page">`

  return body
}

function generateTop(data) {

  let company_name = "";
  let current_dateTime = "";

  //if no data found
  if (data.length > 0) {
    company_name = data[0].company_name;
    current_dateTime = data[0].current_dateTime;
  } else {
    let config = settings.getData()
    company_name = config.company;
    current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
  }

  var table = `
    <div class="dataCont providerProfit-dataCont dn">
      <div ${css.title}>${company_name}</div>
      <div ${css.subtitle}>Providers Accounts Profits All Report As Of  ${current_dateTime}</div>
  `;



  return table

}/**/

function generateTable(data) { //console.log('data>>>', data) 

  var totals = {
    total_last_24_hours: 0,
    total_last_24_hours_percent: 0,
    total_last_24_hours_income: 0,

    total_last_7_days: 0,
    total_last_7_days_percent: 0,
    total_last_7_days_income: 0,

    total_last_15_days: 0,
    total_last_15_days_percent: 0,
    total_last_15_days_income: 0,

    total_last_30_days: 0,
    total_last_30_days_percent: 0,
    total_last_30_days_income: 0,

    total_last_90_days: 0,
    total_last_90_days_percent: 0,
    total_last_90_days_income: 0,

    total_over_90_days: 0,
    total_over_90_days_percent: 0,
    total_over_90_days_income: 0,

    grandTotal: 0
  };
  var nextFormat = 0;


  var table = `
    <h2 ${css.f15}>Providers Vs Profits Amounts: This is a financial document that provides information about money 
      earned to a company by its providers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
      <tr >
        <th ${css.th}>Provider</th>
        <th ${css.th}>Last 24 hours</th>
        <th ${css.th}>Last 7 days</th>
        <th ${css.th}>Last 15 days</th>
        <th ${css.th}>Last 30 days</th>
        <th ${css.th}>Last 90 days</th>
        <th ${css.th}>Over 90 days</th>
        <th ${css.th}>Total</th>   
      </tr> 
  `;
  //if no data found
  if (data.length == 0) {
    table += `
      <tr>
        <td ${css.td} colspan="8"  ><div align="center"><h3>No Profits Were Found.</h3></div></td>
      </tr> 
    `;

    table += `</table>`

    return table
  }

  for (let i = 0; i < data.length; i++) { //console.log('for>>>', data.length)


    let detailHtml_24_hours = parseFloat(data[i].last_24_hours.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
       "source":"dt", "period":"1" } ] }'` : '';

    let detailHtml_7_days = parseFloat(data[i].last_7_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
      "source":"dt", "period":"2" } ] }'`  : '';

    let detailHtml_15_days = parseFloat(data[i].last_15_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
      "source":"dt", "period":"3" } ] }'`   : '';

    let detailHtml_30_days = parseFloat(data[i].last_30_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
      "source":"dt", "period":"4" } ] }'` : '';

    let detailHtml_90_days = parseFloat(data[i].last_90_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
      "source":"dt", "period":"5" } ] }'`   : '';

    let detailHtml_over_90_days = parseFloat(data[i].over_90_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"customer", "elem":"report", "reportType":"profitPeriod", "entity":"customer", "dbid":"${data[i].customer_id}",
          "source":"dt", "period":"6" } ] }'`  : '';


    totals.total_last_24_hours += parseFloat(data[i].last_24_hours.replace(/[$,]/g, ''));
    totals.total_last_24_hours_income += parseFloat(data[i].last_24_hours_income.replace(/[$,]/g, ''));

    totals.total_last_7_days += parseFloat(data[i].last_7_days.replace(/[$,]/g, ''));
    totals.total_last_7_days_income += parseFloat(data[i].last_7_days_income.replace(/[$,]/g, ''));

    totals.total_last_15_days += parseFloat(data[i].last_15_days.replace(/[$,]/g, ''));
    totals.total_last_15_days_income += parseFloat(data[i].last_15_days_income.replace(/[$,]/g, ''));

    totals.total_last_30_days += parseFloat(data[i].last_30_days.replace(/[$,]/g, ''));
    totals.total_last_30_days_income += parseFloat(data[i].last_30_days_income.replace(/[$,]/g, ''));

    totals.total_last_90_days += parseFloat(data[i].last_90_days.replace(/[$,]/g, ''));
    totals.total_last_90_days_income += parseFloat(data[i].last_90_days_income.replace(/[$,]/g, ''));

    totals.total_over_90_days += parseFloat(data[i].over_90_days.replace(/[$,]/g, ''));
    totals.total_over_90_days_income += parseFloat(data[i].over_90_days_income.replace(/[$,]/g, ''));

    totals.grandTotal += parseFloat(data[i].total_earnings.replace(/[$,]/g, ''));

    let percentage_24_hours = safePercentage(
      parseFloat(data[i].last_24_hours.replace(/[$,]/g, '')),
      parseFloat(data[i].last_24_hours_income.replace(/[$,]/g, ''))
    );

    let percentage_7_days = safePercentage(
      parseFloat(data[i].last_7_days.replace(/[$,]/g, '')),
      parseFloat(data[i].last_7_days_income.replace(/[$,]/g, ''))
    );

    let percentage_15_days = safePercentage(
      parseFloat(data[i].last_15_days.replace(/[$,]/g, '')),
      parseFloat(data[i].last_15_days_income.replace(/[$,]/g, ''))
    );

    let percentage_30_days = safePercentage(
      parseFloat(data[i].last_30_days.replace(/[$,]/g, '')),
      parseFloat(data[i].last_30_days_income.replace(/[$,]/g, ''))
    );

    let percentage_90_days = safePercentage(
      parseFloat(data[i].last_90_days.replace(/[$,]/g, '')),
      parseFloat(data[i].last_90_days_income.replace(/[$,]/g, ''))
    );

    let percentage_over_90_days = safePercentage(
      parseFloat(data[i].over_90_days.replace(/[$,]/g, '')),
      parseFloat(data[i].over_90_days_income.replace(/[$,]/g, ''))
    );

    table += `
      <tr ${rowStyle(i)}>
        <td ${css.td}>${data[i].provider_name}</td>
        <td ${css.td} ${detailHtml_24_hours}>${data[i].last_24_hours_income}<br>${data[i].last_24_hours}<br><small>${math.percentFormat(percentage_24_hours)}</small></td>
        <td ${css.td} ${detailHtml_7_days}>${data[i].last_7_days_income}<br>${data[i].last_7_days}<br><small>${math.percentFormat(percentage_7_days)}</small></td>
        <td ${css.td} ${detailHtml_15_days}>${data[i].last_15_days_income}<br>${data[i].last_15_days}<br><small>${math.percentFormat(percentage_15_days)}</small></td>
        <td ${css.td} ${detailHtml_30_days}>${data[i].last_30_days_income}<br>${data[i].last_30_days}<br><small>${math.percentFormat(percentage_30_days)}</small></td>
        <td ${css.td} ${detailHtml_90_days}>${data[i].last_90_days_income}<br>${data[i].last_90_days}<br><small>${math.percentFormat(percentage_90_days)}</small></td>
        <td ${css.td} ${detailHtml_over_90_days}>${data[i].over_90_days_income}<br>${data[i].over_90_days}<br><small>${math.percentFormat(percentage_over_90_days)}</small></td>
        <td ${css.td}>${cashVal(parseFloat(data[i].total_earnings.replace(/[$,]/g, '')))}</td>
      </tr> 
    `;
    nextFormat = i + 1;
  }

  totals.total_last_24_hours_percent = safePercentage(totals.total_last_24_hours, totals.total_last_24_hours_income);
  totals.total_last_7_days_percent = safePercentage(totals.total_last_7_days, totals.total_last_7_days_income);
  totals.total_last_15_days_percent = safePercentage(totals.total_last_15_days, totals.total_last_15_days_income);
  totals.total_last_30_days_percent = safePercentage(totals.total_last_30_days, totals.total_last_30_days_income);
  totals.total_last_90_days_percent = safePercentage(totals.total_last_90_days, totals.total_last_90_days_income);
  totals.total_over_90_days_percent = safePercentage(totals.total_over_90_days, totals.total_over_90_days_income);

  //PRINITNG EACH COLUMM TOTAL
  table += `
    <tr ${rowStyle(nextFormat)}>
      <td ${css.totalLabel}>Total</td>
      <td ${css.td} ><h5>${cashVal(totals.total_last_24_hours_income)}<br>${cashVal(totals.total_last_24_hours)}<br>${math.percentFormat(totals.total_last_24_hours_percent)}</h5></td>
      <td ${css.td} ><h5>${cashVal(totals.total_last_7_days_income)}<br>${cashVal(totals.total_last_7_days)}<br>${math.percentFormat(totals.total_last_7_days_percent)}</h5></td>
      <td ${css.td} ><h5>${cashVal(totals.total_last_15_days_income)}<br>${cashVal(totals.total_last_15_days)}<br>${math.percentFormat(totals.total_last_15_days_percent)}</h5></td>
      <td ${css.td} ><h5>${cashVal(totals.total_last_30_days_income)}<br>${cashVal(totals.total_last_30_days)}<br>${math.percentFormat(totals.total_last_30_days_percent)}</h5></td>
      <td ${css.td} ><h5>${cashVal(totals.total_last_90_days_income)}<br>${cashVal(totals.total_last_90_days)}<br>${math.percentFormat(totals.total_last_90_days_percent)}</h5></td>
      <td ${css.td} ><h5>${cashVal(totals.total_over_90_days_income)}<br>${cashVal(totals.total_over_90_days)}<br>${math.percentFormat(totals.total_over_90_days_percent)}</h5></td>
      <td ${css.td} ><h4>${cashVal(totals.grandTotal)}</h4></td>
    </tr> 
  `;

  table += `</table>`

  return table

}

function safePercentage(numerator, denominator) {
  if (!denominator || denominator === 0 || isNaN(denominator)) {
    return "0.00"; // Retorna un valor predeterminado si el denominador no es válido
  }

  if (!numerator || isNaN(numerator)) {
    numerator = 0; // Asegura que el numerador no sea `null` o `NaN`
  }

  return parseFloat((numerator / denominator) * 100).toFixed(2);
}

function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

  if (i % 2 === 0) { return '' }
  return css.trGray

}